import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import { router } from '@/router';

import OldLoginForm from './OldLoginForm.vue';
import OldLoginService from './old.login.service';
import IOldLoginForm from './old.loginform.interface';

import MigrationFormModal from './MigrationFormModal.vue';
import IMigrationForm from '@/ui/views/old-login/migration.form.interface';
import { useTranslations } from '@/core/translate.mixin';


export default /*#__PURE__*/_defineComponent({
  __name: 'OldLogin',
  props: {
    loginInformationText: null,
    loginButtonText: null,
    initialsText: null,
    userNameText: null,
    passwordText: null,
    userMigratedText: null,
    userMigratedLinkText: null,
    linkToNewLoginPage: null,
    loginPageId: null
  },
  setup(__props: any) {

const props = __props as {
    loginInformationText: string;
    loginButtonText: string;
    initialsText: string;
    userNameText: string;
    passwordText: string;
    userMigratedText: string;
    userMigratedLinkText: string;
    linkToNewLoginPage?: string;
    loginPageId: string;
}



const showSpinner = ref(false);
const error = ref<string>('');
const migrationText = ref<string>('');
const loginFormState = ref<IOldLoginForm>();
const showModal = ref(false);
const userName = ref<string>('');
const showSkipButton = ref(false);
const showConfirmationMessage = ref(false);
const token = ref<string>('');
const usernameError = ref<boolean>(false);

async function login(userCredentials: IOldLoginForm) {
    loginFormState.value = userCredentials;
    error.value = '';
    showSpinner.value = true;
    const destinationUrl = router.currentRoute.query.url as string;

    const serverResponse = OldLoginService.login(userCredentials, props.loginPageId, destinationUrl);

    serverResponse.then(response => {
        const { isLoggedIn, redirectUrl, errorMessage, isUserMigrated, migrationToken, userHasSkippedMigration, username } = response;

        if (isLoggedIn) {
            OldLoginService.loginRedirect(redirectUrl);
        } else if (errorMessage) {
            error.value = errorMessage;
        } else if (isUserMigrated && props.linkToNewLoginPage) {
            migrationText.value = props.userMigratedText + '<a href=' + props.linkToNewLoginPage + '>' + props.userMigratedLinkText + '</a>';
        } else {
            startMigrationFlow(username, userHasSkippedMigration, migrationToken);
        }
    }).finally(() => showSpinner.value = false);
};

function startMigrationFlow(username: string, userHasSkippedMigration: boolean, migrationToken: string) {
    showModal.value = true;
    userName.value = username;
    showSkipButton.value = userHasSkippedMigration === false;
    token.value = migrationToken;
}

const { t } = useTranslations();

let redirectSuccessUrl = '';
function migrate(form: IMigrationForm) {
    const serverResponse = OldLoginService.migrate(form, token.value);

    serverResponse.then(response => {
        const { redirectUrl, errorMessage, usernameInvalid } = response;

        if (redirectUrl) {
            redirectSuccessUrl = redirectUrl;
            showConfirmationMessage.value = true;
        } else if (usernameInvalid) {
            usernameError.value = true;
        } else {
            error.value = errorMessage;
        }
    }).finally(() => showSpinner.value = false);
}

function skipMigration() {
    const destinationUrl = router.currentRoute.query.url as string;
    const serverResponse = OldLoginService.skipMigration(loginFormState.value, props.loginPageId, destinationUrl);

    serverResponse.then(response => {
        const { isLoggedIn, redirectUrl, errorMessage } = response;

        if (isLoggedIn) {
            OldLoginService.loginRedirect(redirectUrl);
        } else {
            error.value = errorMessage;
        }
    }).finally(() => showSpinner.value = false);
}

function closeAndRedirect() {
    if (redirectSuccessUrl) {
        OldLoginService.loginRedirect(redirectSuccessUrl);
    }
}


return { __sfc: true,props, showSpinner, error, migrationText, loginFormState, showModal, userName, showSkipButton, showConfirmationMessage, token, usernameError, login, startMigrationFlow, t, redirectSuccessUrl, migrate, skipMigration, closeAndRedirect, OldLoginForm, MigrationFormModal }
}

})